import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getCurrentUser } from "../core/utils/auth";
import { STORAGE_KEYS } from "../core/config/constants";

/**
 * Route protection guard:
 * Verifies both JWT token and user profile exist in localStorage.
 * If not authenticated, redirects directly to /signin.
 */
export default function ProtectedRoute({ children }) {
  const location = useLocation();
  const token = localStorage.getItem(STORAGE_KEYS.TOKEN || "token");
  const user = getCurrentUser();

  if (!token || !user) {
    return <Navigate to="/signin" state={{ from: location }} replace />;
  }

  return children;
}
